import { withStyles } from '../../tools/withStyles';
import { Component } from './Animation';

const Animation = withStyles(() => ({}))(Component);

export { Animation };

// Commit trace: 2025-12-07T07:59:36 - refactor: clean up code structure in index.js

// Commit trace: 2026-01-27T13:22:03 - refactor: clean up code structure in index.js
